export default "<h1 class=\"page-title\">{{ drinkForCause[0].text }}</h1>\n<div class=\"drinks-for-a-cause\">\n  {{ drinkForCause[0].text1 }}\n</div>\n";